import { render, staticRenderFns } from "./outReceipt.vue?vue&type=template&id=20e801fd"
import script from "./outReceipt.vue?vue&type=script&lang=js"
export * from "./outReceipt.vue?vue&type=script&lang=js"
import style0 from "./outReceipt.vue?vue&type=style&index=0&id=20e801fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports